import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { Loading } from "../Other/Loading";
import axios from "../../axios";
import { removeDash, removeSpaces } from "../../_helpers";
const { REACT_APP_LOGIN_API_BASEURL } = process.env;

export default function Courses() {
  const { subCategory, type } = useParams();

  const [loadData, setLoadData] = useState(false);
  const [courseList, setCourseList] = useState(null);
  //console.log("courseList", courseList);

  const fetchData = async () => {
    setLoadData(true);
    setCourseList(null);

    let data = {};
    if (type) {
      data = {
        subCategory: type.replace(/\-/g, " "),
        category: subCategory.replace(/\-/g, " ")
      };
    } else {
      data = {
        category: subCategory.replace(/\-/g, " ")
      };
    }

    try {
      const response = await axios.post(
        `${REACT_APP_LOGIN_API_BASEURL}/course?page=${1}`,
        data
      );
      setLoadData(false);
      setCourseList(response.data.data.courses);
    } catch (error) {
      setLoadData(false);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  const { t } = useTranslation();

  const word = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <>
      {loadData ?
        <div className="loading-div">
          <Loading />
        </div> :
        <div className="cat-page">
          <div className="inner-wrapper">
            <div className="page-title">
              {type ? word(removeDash(type)) : word(removeDash(subCategory))}
            </div>
          </div>

          <div className="inner-wrapper">
            {courseList && courseList.length > 0 ? courseList.map((item) => {
              return (
                <div className="tile" key={item.id}>
                  <div className="underlay">
                    <img src={item.imageFiles.hasOwnProperty("fileName") ? process.env.REACT_APP_LOGIN_API_BASEURL + "/" + (item.imageFiles?.fileName) : ""} alt="Categories"  loading="lazy" />
                  </div>

                  <div className="cat_info">
                    <div className="tile-title">{item.CourseName}</div>
                    {/* <div className="tile-title">{item.SubCategory}</div> */}
                    {/* <div className="no-of-cats">{item.catNos}</div> */}
                    {/* <div className="all-courses-links">
                      <a href="#">
                        {t("Checkout all")} {item.catNos} {t("courses")}
                      </a>
                    </div> */}
                  </div>
                </div>
              );
            }) :
              <div className="courses-tile-loader">
                No Courses Found
              </div>
            }
          </div>
        </div>
      }
    </>
  );
}
